import { z } from 'zod';

export const healthCheckStatusSchema = z.enum(['ok', 'fail']);

export const livenessResponseSchema = z.object({
  status: z.literal('ok'),
});

export const readinessResponseSchema = z.object({
  status: healthCheckStatusSchema,
  checks: z.record(
    z.string(),
    z.object({
      status: healthCheckStatusSchema,
      latencyMs: z.number().nonnegative(),
    }),
  ),
});
export type ReadinessResponse = z.infer<typeof readinessResponseSchema>;
